import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { RestService } from '../../rest.service';
import { NotificationService } from '../../notification.service';
import { environment } from '../../../environments/environment.prod';
import { EncryptedDecryptedService } from '../../service/encrypted-decrypted.service';
@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {
  public param1: any;
  public tokenKey: any;
  public user: any;
  public azureUserMail: string;
  public password: string;
  public employeeDetailsObj: any = {}
  public result: boolean = true;
  public employeeId: any;
  public url: any;
  encDecService: any;
  loginFormGroup: any;
  constructor(private route: ActivatedRoute, private restService: RestService, private router: Router,

    private encryptedDecryptedService: EncryptedDecryptedService,
    private spinner: NgxSpinnerService, private notify: NotificationService) {
  }

  ngOnInit(): void {
    this.url = sessionStorage.getItem('loginUrl');
    sessionStorage.clear();
    const encodedMail = this.route.snapshot.params['azureAdMail'];
    this.azureUserMail = atob(encodedMail)
    sessionStorage.setItem('azureUserMail', this.azureUserMail);

    const email = this.encryptedDecryptedService.set(
      "ln&t$ecretKeyG%C",
      this.azureUserMail
    );

    this.password = this.encryptedDecryptedService.set(
      "ln&t$ecretKeyG%C",
      "test@123"
    );
    this.employeeDetailsObj.email = email;
    this.employeeDetailsObj.password = this.password
    this.spinner.show()
    this.restService.postModel(this.employeeDetailsObj, '/screen/GetUser').subscribe((response) => {
      this.result = response.status;
      if (this.result) {
        this.restService.setUserLoggedIn(true);
        sessionStorage.setItem('userId', response.userId);
        sessionStorage.setItem('companyId', response.companyId);
        sessionStorage.setItem('employeeId', response.employeeId);
        sessionStorage.setItem('email', response.email);
        sessionStorage.setItem('roleId', response.roleId);
        sessionStorage.setItem('deptId', response.deptId);
        sessionStorage.setItem('name', response.name);
        sessionStorage.setItem('departmentName', response.departmentName);
        sessionStorage.setItem('roleName', response.roleName);
        sessionStorage.setItem('token', response.token);
        sessionStorage.setItem('companyId', response.companyId);
        sessionStorage.setItem('companyName', response.companyName);
        sessionStorage.setItem('projectId', response.projectId);
        this.employeeId = sessionStorage.getItem('employeeId');
        this.resetPivotData();
        if (this.url == null || this.url == 'undefined') {
          this.router.navigateByUrl('/dashboard');
        } else {
          this.url = this.url.replaceAll("_", "/");
          this.router.navigateByUrl("/" + this.url);
        }
      } else {
        this.notify.showError('User Not Found', '');
        this.router.navigateByUrl('/404-page');
      }
      this.spinner.hide();
    });
  }
  resetPivotData() {
    this.restService.model(`/config/deleteTestPivotDataByEmployeeId/${this.employeeId}`).subscribe(() => { })
    this.restService.model(`/config/deleteMitigationPivotDataByEmployeeId/${this.employeeId}`).subscribe(() => { })
    this.restService.model(`/config/deleteRiskPivotDataByEmployeeId/${this.employeeId}`).subscribe(() => { })
    this.restService.model(`/config/deleteIncidentPivotDataByEmployeeId/${this.employeeId}`).subscribe(() => { })
  }
}
